var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHeartCarouselAnimation2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icHeartCarouselAnimation2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.20312069,1.29362568 C-0.401959068,3.01764946 -0.400121132,5.78527218 1.20312069,7.51066011 L7.74971296,14.5573809 C7.81400614,14.627142 7.90344096,14.6666667 7.99700045,14.6666667 C8.09055994,14.6666667 8.17999476,14.627142 8.24428795,14.5573809 C10.4285729,12.2112046 12.6118882,9.86235588 14.7961901,7.51612718 C16.40127,5.79207371 16.40127,3.02313574 14.7961901,1.29908401 C13.1911273,-0.424965969 10.5673201,-0.425004396 8.96224025,1.29908401 L7.99965525,2.33070955 L7.03708727,1.29362568 C6.23453885,0.431599812 5.17404972,1.98573114e-14 4.11744067,1.98573114e-14 C3.06083163,0 2.00565209,0.431598066 1.20312069,1.29362568 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icHeartCarouselAnimation2",
    fill: "#7EC34D",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeartCarouselAnimation2);
export default __webpack_public_path__ + "static/media/icHeartCarouselAnimation2.ee285ef96475953fd020a6306d1258ba.svg";
export { ForwardRef as ReactComponent };